import { Textarea, TextareaInput } from "../../../../../ui/textarea";
import type { FieldControlProps } from "../fieldTypes";

const TextAreaField = ({
  field,
  value,
  onChange,
  disabled,
  invalid,
  onBlur,
}: FieldControlProps) => (
  <Textarea size="md" isDisabled={disabled} isInvalid={invalid}>
    <TextareaInput
      value={typeof value === "string" ? value : ""}
      onChangeText={onChange}
      onBlur={onBlur}
      accessibilityLabel={field.label}
    />
  </Textarea>
);

export default TextAreaField;
